/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from 'prop-types';

import { StoryPageContent } from './story.js';

const StoryPublicPagePreview = ({ data, config, renderStoryPageContent }) => {
  const isInfiniteScrollEnabled = config?.['pagebuilder-config']?.infiniteScroll?.infiniteScrollType !== 'disabled';
  return StoryPageContent(data, config, renderStoryPageContent, true, isInfiniteScrollEnabled ? 0 : undefined);
};

StoryPublicPagePreview.propTypes = {
  config: PropTypes.object,
  data: PropTypes.object,
  renderStoryPageContent: PropTypes.func
};
export { StoryPublicPagePreview };
